import { z } from 'zod';
import { opgavekompleksetTaskEntrySchema } from './tasks/_entry-data.js';

const opgavekompleksetEntryDataSchema = z.object({
  activeTaskId: z.string().nullish().default(null),
  attempt: z.number().default(1),
  startTime: z.number().default(() => Date.now()),
  endTime: z.number().default(() => Date.now()),
  tasks: z.record(z.string(), z.preprocess(val => {
    if (typeof val === "string") {
      return JSON.parse(val);
    } else {
      return val;
    }
  }, opgavekompleksetTaskEntrySchema)).default({})
});

export { opgavekompleksetEntryDataSchema };
//# sourceMappingURL=_entry-data.js.map
